var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClauses({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "menu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 6H3a1 1 0 0 0 0 2h26a1 1 0 0 0 0-2ZM3 17h13a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2ZM25 24H3a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "currentColor",
    className: "fill-000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClauses);
export default __webpack_public_path__ + "static/media/icon-clauses.9ba2e807bddb05bcf1fb80c9d74b32ab.svg";
export { ForwardRef as ReactComponent };